export class ExportOrganizationCostData400Response {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "error",
            "baseName": "error",
            "type": "string",
            "format": "tobedefined"
        }
    ];
    static getAttributeTypeMap() {
        return ExportOrganizationCostData400Response.attributeTypeMap;
    }
    constructor() {
    }
}
